import React, { useEffect, useRef } from 'react';

const get_cbid = () => {
	let em = document.getElementById("Cookiebot");
	if (!em) return null;
	let cbid = em.getAttribute("data-cbid");
	if (!cbid) return null;
	return cbid;
};

const using_cookiebot = () => !!get_cbid();

const CookiebotPage2 = (props) => {
	let ref = useRef();

	useEffect(() => {
		if (!ref.current) {
			console.log("NOT installing cookiebot");
			return;
		}

		console.log("INSTALLING cookiebot");

		const script = document.createElement("script");
		script.id = "CookieDeclaration";
		script.src = "https://consent.cookiebot.com/"+props.cbid+"/cd.js";
		script.type = "text/javascript";
		script.async = "async";

		ref.current.innerHTML = "";
		ref.current.appendChild(script);

		return () => { script.remove(); };
	}, [ref]);

	return <div ref={ref}/>
};


const CookiebotPage = (props) => {
	let cbid = get_cbid();
	if (!cbid) return null;
	return <CookiebotPage2 cbid={cbid}/>
};

export {
	using_cookiebot,
	CookiebotPage,
}



// WEBPACK FOOTER //
// ./src/c/Cookiebot.js